import ic_cam from '@/assets/icons/core/ic_core_camera.svg?raw';
import ic_edit from '@/assets/icons/core/ic_core_edit.svg?raw';
import ic_status_done from '@/assets/icons/status/ic_status_done.svg?raw';
import { Selection, select } from "d3";
import "../../../styles/pages/Event-photo.scss";
import { _APP_DATA } from "../../data/AppData";
import { EEventId } from "../../data/models/Entities";
import { _SvEventoRegistrarFoto } from "../../data/services/Evento";
import { PhotoEventUploadPayload } from "../../data/services/Photo";
import { _SERVER_IMAGES_ACCEPT } from "../../data/utils/General";
import { _GetCleanHash } from "../../routes/Router";
import { _HistoryBack } from "../../routes/UIManager";
import { _CanUploadInBackground, _EnqueuePhotoEventForBunchUpload, _IS_SAFARI_NAVIGATOR } from "../../utils/Device";
import _L, { _HttpMsg } from "../../utils/Labels";
import { BaseUIEvent } from "../bases/BaseUIEvent";
import { _LoadFileManager } from "../components/FileManager";
import { ImageViewer } from "../components/ImageViewer";
import { LOADING } from "../components/Loading";
import { ShowToast } from "../components/Toast";
import { _CreateElementFromHTML } from "../utils/General";

enum EStatusPhoto {
    NOT_DEFINED = 0,
    SELECTED = 1,
    UPLOADED = 2,
    ERROR = 3
}

interface IPhotoItem {
    id: number,
    file: any,
    url: string,
    status: EStatusPhoto
};


export class EventPhoto extends BaseUIEvent {

    private listPhotos: IPhotoItem[] = [];
    private inProcessPhotosList: IPhotoItem[] = [];
    private expectedWorkerResponses: number = 0;

    private divListPhotos: Selection<HTMLDivElement, any, any, any>;

    constructor() {
        super('ui-event-photo', EEventId.PHOTOS);
    }

    protected InitClass(): void {
        this.listPhotos = [];
        this.divListPhotos = this.bodyContainer.classed("list-photos", true)
        this.SetGridPhotos();
        this.AddSaveBtn();

        this.TurnOnWorkerResponseListener();
    }

    private SetGridPhotos() {
        const bubblesgroup = this.divListPhotos.selectAll<HTMLDivElement, any>(".photo-item").data(this.listPhotos);

        bubblesgroup.exit().remove();
        bubblesgroup.enter().append("div")
            .classed("photo-item", true)
            .each((_, i, divs) => {
                const elemnt = select(divs[i]);
                elemnt.append("img").classed("photo", true);
                elemnt.append("div")
                    .classed("ic_edit", true)
                    .call((btn) => {
                        btn.append(() => _CreateElementFromHTML(ic_edit))
                            .style("height", "100%")
                            .style("width", "100%");
                    })
                elemnt.append("div")
                    .classed("uploaded", true)
                    .call((btn) => {
                        btn.append(() => _CreateElementFromHTML(ic_status_done))
                    })

            })
            .merge(bubblesgroup)
            .on('click', function (_, d) {
                if (d.status == EStatusPhoto.UPLOADED) return;

                const isActive = d.status == EStatusPhoto.SELECTED;
                d.status = isActive ? EStatusPhoto.NOT_DEFINED : EStatusPhoto.SELECTED;
                select(this).attr("class", "photo-item status-photo-" + d.status);
            })
            .each((datum, i, divs) => {
                const elemnt = select(divs[i]);

                elemnt.attr("class", "photo-item status-photo-" + datum.status);

                elemnt.select(".photo").attr("src", datum.url)
                elemnt.select(".ic_edit")
                    .on("click", (e) => {
                        e.stopPropagation();

                        new ImageViewer()
                            .SetImage(datum.url)
                            .AddEditOptions()
                            .OnSuccessCompletion((file) => {
                                datum.url = file.b64
                                fetch(file.b64)
                                    .then(response => response.blob())
                                    .then(blob => {
                                        datum.file = blob;
                                        elemnt.select(".photo").attr("src", datum.url);
                                    });
                            })
                    })
            });
    }

    protected AddSaveBtn() {
        super.AddSaveBtn();

        const self = this;
        this.footerContainer.append("div").classed("btn-take-pic", true)
            .call((btn) => {
                btn.append(() => _CreateElementFromHTML(ic_cam))
                    .style("height", "100%")
                    .style("width", "100%");
            })
            .on("click", () => {
                _LoadFileManager({
                    multiple: true,
                    // DOTEST Es necsario en todas las implementaciones
                    // * capture=true evita que aparezca el selector de fotos, solo abre la camara
                    // * capture=false muestra el selector y camara
                    // ¿Es así en todos los dispositivos iOS?
                    capture: _IS_SAFARI_NAVIGATOR ? false : true,
                    accept: _SERVER_IMAGES_ACCEPT.toString(),
                    onChange() {
                        LOADING.Show();
                        return true;
                    },
                    onLoadFile(b64, file) {
                        const objPhoto: IPhotoItem = {
                            id: Date.now(),
                            file: file,
                            url: b64,
                            status: EStatusPhoto.NOT_DEFINED
                        };

                        self.listPhotos.push(objPhoto);

                        self.SetGridPhotos();
                    },
                    onFinishLoadFiles() {
                        LOADING.Dismiss();
                    },
                })
            });
    }

    protected OnSaveClick(): void {
        if (this.childList.length === 0) {
            ShowToast(_L("photo.title"), _L("photo.alumno_required"), "info");
            return;
        }

        if (this.listPhotos.length === 0) {
            ShowToast(_L("photo.title"), _L("photo.loadphoto_required"), "info");
            return;
        }

        let photosToUpload = this.listPhotos.filter((datum) => datum.status == EStatusPhoto.SELECTED);
        if (photosToUpload.length == 0) {
            ShowToast(_L("photo.title"), _L("photo.selectphoto_required"), "info");
            return;
        }

        LOADING.Show();

        let idsChild = this.childList.map((d) => d.IdChild);
        this.inProcessPhotosList = photosToUpload;
        this.expectedWorkerResponses = photosToUpload.length;
        if (!_CanUploadInBackground()) {
            this.UploadPhoto(0, photosToUpload, idsChild);
            return;
        }

        this.SendPhotosBatchBackgroundLoad(photosToUpload, idsChild);
    }

    async SendPhotosBatchBackgroundLoad(photosToSend: IPhotoItem[], studentsIDS: number[]) {
        const schoolID = _APP_DATA.userData.IdKinder;
        const userID = _APP_DATA.userData.IdUsuario;
        const groupID = _APP_DATA.userData.IdGrupo;
        const orgID = _APP_DATA.userData.IdOrganizacion;

        const batchID = "BATCH_" + Date.now();
        const totalPhotosInBatch = photosToSend.length;
        for (let i = 0; i < photosToSend.length; i++) {
            const photo = photosToSend[i];
            const uniqueID = `IMG_${photo.id}`;

            const payload: PhotoEventUploadPayload = {
                id: uniqueID,
                fileName: uniqueID,
                base64Data: photo.url,// photo.base64,
                schoolID: schoolID,
                userID: userID,
                groupID: groupID,
                organizationID: orgID,
                studentsIDSJson: studentsIDS.join(","),
                eventDateISO: new Date().toISOString(),
                isExtemporal: this.IS_EXTEMPORAL,

                batchID: batchID,
                totalPhotosInBatch: totalPhotosInBatch,
            }

            _EnqueuePhotoEventForBunchUpload(payload);
        }
    }

    private TurnOnWorkerResponseListener() {
        (window as any)._OnPhotoEventUploadStatus = (photoId: string, status: string) => {
            const idNumerico = parseInt(photoId.replace("IMG_", ""));

            const fotoEncontrada = this.inProcessPhotosList.find(p => p.id === idNumerico);

            if (!fotoEncontrada) return;

            if (status === "SUCCESS")
                fotoEncontrada.status = EStatusPhoto.UPLOADED;
            else
                fotoEncontrada.status = EStatusPhoto.ERROR;

            this.SetGridPhotos();

            if (this.expectedWorkerResponses > 0) {
                this.expectedWorkerResponses--;

                if (this.expectedWorkerResponses === 0) {
                    this.EvalProcessClosure();
                }
            }
        }
    }

    UploadPhoto(indexPhoto: number, photosToUpload: IPhotoItem[], idsChild: number[]) {
        let datumPhoto = photosToUpload[indexPhoto];

        if (datumPhoto !== undefined && datumPhoto !== null) {
            const dtEvent = new Date();
            _SvEventoRegistrarFoto(idsChild, datumPhoto.file, dtEvent, this.IS_EXTEMPORAL, async (STATUS) => {
                if (STATUS === 1)
                    datumPhoto.status = EStatusPhoto.UPLOADED;
                else
                    datumPhoto.status = EStatusPhoto.ERROR;

                this.SetGridPhotos();

                await new Promise<void>(resolve => setTimeout(() => resolve(), 1000)); // TESTING (prod) pausa para disminuir trafico en rst-teachers
                this.UploadPhoto((indexPhoto + 1), photosToUpload, idsChild);
            });

        } else {
            this.EvalProcessClosure()
        }
    }

    private EvalProcessClosure() {
        if (this.inProcessPhotosList.filter((d) => d.status == EStatusPhoto.UPLOADED).length === 0) {
            ShowToast(_L("photo.title"), _HttpMsg("evento/RegistrarFotoV3", -1), "error");
        } else {
            ShowToast(_L("photo.title"), _HttpMsg("evento/RegistrarFotoV3", 1), 'success');
        }

        let currentHash = _GetCleanHash(null);
        const isInEventPhotoView = "eventsphotos" == currentHash
        let totalUp = this.listPhotos.filter((d) => d.status == EStatusPhoto.UPLOADED).length;
        if (totalUp === this.listPhotos.length && isInEventPhotoView) {
            _HistoryBack();
        }

        if (isInEventPhotoView) {
            LOADING.Dismiss();
        }
    }

    public OnDestroy(): void {
        (window as any)._OnPhotoUploadStatus = undefined;
        this.listPhotos = [];
        this.inProcessPhotosList = [];
        this.expectedWorkerResponses = 0;

        super.OnDestroy();
    }
}
